import InboxItem from 'records/InboxItem';
import transformFolder from 'utils/transforms/transformFolder';
import transformInboxItem from 'utils/transforms/transformInboxItem';
import {javaApiFor} from '../api';

const api = javaApiFor('/api/folders');

export default {
  fetchMail(filters, page) {
    if (filters.viewAll) {
      const queryFilters = filters
        // viewAll ignores these params
        .delete('folderId')
        .delete('tagId')
        .toJS();

      return api.postJson('/items', {...queryFilters, page, pageSize: 75}).then(transformFolder);
    } else {
      const queryFilters = filters
        // folder id is in the path
        .delete('folderId')
        .toJS();

      return api
        .postJson(`/${filters.folderId}/items`, {
          ...queryFilters,
          page,
          pageSize: 75,
        })
        .then(transformFolder);
    }
  },

  fetchMailItem(id) {
    return api.getJson(`/items/${id}`).then(item => new InboxItem(transformInboxItem(item)));
  },

  togglePinned(inboxItem) {
    return api.postJson('/toggle_pinned', {id: inboxItem.id});
  },

  markAsViewed(inboxItem) {
    return api.postJson('/mark_as_viewed', {id: inboxItem.id});
  },

  changeFolder(inboxItem, from, to) {
    return api.postJson(`/${from}/to/${to}`, {
      id: inboxItem.id,
    });
  },

  // 'from' shouldnt be needed in the api path but it is
  bulkMoveFolder({filters, ids, from, to}) {
    return api.postJson(`/${from}/to/${to}`, {
      ids: ids && ids.toJS(),
      all: !!filters,
      listOptions:
        filters &&
        filters
          .searchValue()
          // folderId part of url, not request body
          .delete('folderId')
          .toJS(),
    });
  },

  // folder id shouldnt be needed in the api path but it is
  bulkMarkAsRead({filters, folderId, ids}) {
    return api.postJson(`/${folderId}/mark_as_viewed`, {
      ids: ids && ids.toJS(),
      all: !!filters,
      listOptions:
        filters &&
        filters
          .searchValue()
          // folderId part of url, not request body
          .delete('folderId')
          .toJS(),
    });
  },

  // folder id shouldnt be needed in the api path but it is
  bulkSetPinned({filters, ids, folderId, pinned}) {
    return api.postJson(`/${folderId}/set_pinned`, {
      pinned,
      items: {
        ids: ids && ids.toJS(),
        all: !!filters,
        listOptions:
          filters &&
          filters
            .searchValue()
            // folderId part of url, not request body
            .delete('folderId')
            .toJS(),
      },
    });
  },

  fetchInboxMentions() {
    return api.getJson('/mention_notifications/count?unread=true');
  },

  markCallAsRead(callId) {
    // Returns callId for store to update items
    return api.postJson(`/mark_call_as_viewed/${callId}`, {}).then(() => callId);
  },
};
